import React from "react";
import { Card } from "react-bootstrap";
import { Link } from "react-router-dom";
import StatusPill from "../../components/statusPill";
import { Product } from "../../models/product";
import "./productCard.css";
import Rating from "./productRating";

const ProductCard: React.FC<{
  model: Product;
  onChange?: (event: React.ChangeEvent) => void;
  selected?: boolean;
  compareable?: boolean;
  width?: string;
}> = (props) => {
  let cardStyle = {};
  if (props.width) {
    cardStyle = { width: props.width };
  }
  return (
    <Card className="product-card-body" style={cardStyle}>
      <div className="product-card-upper">
        {props.compareable && (
          <div className="product-card-checkbox-container">
            <input
              className="compare-checkbox"
              type="checkbox"
              id={`compare-checkbox-${props.model.sku}`}
              name="compare"
              value={props.model.sku}
              onChange={props.onChange}
              checked={props.selected}
            />
            <label
              className="compare-label"
              htmlFor={`compare-checkbox-${props.model.sku}`}
            >
              Compare
            </label>
          </div>
        )}
        <div className="product-card-img-container">
          <Link to={`/model/${props.model.sku}`}>
            <img
              className="product-card-image"
              alt={props.model.name}
              src={props.model.image}
            />
          </Link>
        </div>
        <div className="item-title-container">          
          <a className="model-title-link" href={`/model/${props.model.sku}`}>{props.model.name}</a>
          <br></br>
          <span> Model: {props.model.sku}</span>
        </div>
      </div>
      <Rating sku={props.model.sku} />
      <div className="product-card-lower">
        <StatusPill status={props.model.state} />
      </div>
    </Card>
  );
};

export default ProductCard;
